import React from 'react'
import { RegisterOptions, UseFormReturn } from 'react-hook-form'
import { numericInputProps } from './props-autocomplete'
import { GenericTextInput } from './default-text-input'

type Props = {
  form: UseFormReturn<any>
  name: string
  label?: string
  variant?: 'standard' | 'filled' | 'outlined'
  placeholder?: string
  disabled?: boolean
  options?: RegisterOptions
  inputProps?: any
}

export const NumberInput: React.FC<Props> = ({
  form,
  name,
  variant = 'outlined',
  placeholder = undefined,
  label = 'Код',
  disabled = false,
  options,
  inputProps,
}): JSX.Element => {
  const { register, formState } = form

  return (
    <GenericTextInput
      register={register(name, { required: true, disabled, ...options })}
      InputProps={{ inputProps: { ...(numericInputProps as any), ...inputProps } }}
      placeholder={placeholder}
      disabled={disabled}
      label={label}
      variant={variant}
      helperText={formState.errors[name]?.message}
    />
  )
}
